import { gql } from "graphql-request";

/** Shared `me` selection for session / onboarding gating (keep in sync with {@link AuthProvider}). */
export const ME_DOCUMENT = gql`
  query Me {
    me {
      id
      email
      name
      first_name
      last_name
      company
      jobtitle
      onboarding_completed
      capacity_status {
        state
        reason
        message
        onboarding_message
        global_gpu_available
      }
      chat_settings {
        globally_enabled
      }
      docs_settings {
        globally_enabled
      }
      billing_summary {
        billing_complete
        welcome_credit_amount_cents
      }
      extra_roles
    }
  }
`;

export type MeCapacityStatus = {
  state: string;
  reason: string | null;
  message: string;
  onboarding_message: string;
  global_gpu_available: boolean;
};

export type MeChatSettings = {
  globally_enabled: boolean;
};

export type MeDocsSettings = {
  globally_enabled: boolean;
};

export type MeBillingSummary = {
  billing_complete: boolean;
  welcome_credit_amount_cents: number;
};

export type MeQueryData = {
  me: {
    id: string;
    email: string;
    name: string | null;
    first_name: string | null;
    last_name: string | null;
    company: string | null;
    jobtitle: string | null;
    onboarding_completed: boolean;
    capacity_status: MeCapacityStatus;
    chat_settings: MeChatSettings;
    docs_settings: MeDocsSettings;
    billing_summary: MeBillingSummary;
    extra_roles: string[];
  };
};
